module.exports = __webpack_public_path__ + "static/media/Aalidhra12a2.30fb0164.jpg";